export default __webpack_public_path__ + "static/media/InDoorMap-names1.105e06d6.png";